<template>
  <question
    prevTitle="Cancel"
    nextTitle="Continue"
    :prevEnabled="true"
    :nextEnabled="buttonEnabled"
    @prevClick="cancel"
    @nextClick="next"
  >
    <div v-if="companyType === 'Limited Company'" class="stretchBox">
      <reg @found="foundFunc" @setName='setName' />
    </div>
    <div v-else class="stretchBox">
      <div class="detailBox rounded shadow">
        <h3>Enter your company details:</h3>
        <input type="text" v-model="companyName" placeholder="Company name" />
        <br/>
        <input type="text" v-model="postCode" placeholder="Post code" />
      </div>
    </div>
  </question>
</template>

<script>
import reg from "@/views/questions/regFind.vue";
import question from "@/components/questionTemplate";
export default {
  components: {
    reg,
    question,
  },
  data: function () {
    return {
      companyName: null,
      postCode: null,
      found: false,
    };
  },
  methods: {
    foundFunc: function (val) {
        this.found = val
    },
    setName: function (name) {
        this.companyName = name
    },
    cancel: function () {
      if (this.lastRoute) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    next: function () {
      this.$store.dispatch("setFormData", {
        businessName: this.companyName,
        postCode: this.postCode,
      });
      this.$router.push('2');
    },
  },
  computed: {
    companyType: function () {
      return this.$store.state.formData.companyType;
    },
    buttonEnabled: function () {
      if (this.companyType === "Limited Company") {
        if (this.found === true) {
          return true;
        }
      } else {
        if (
          this.companyName &&
          this.companyName.length > 3 &&
          this.postCode &&
          this.postCode.length > 3
        ) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  background-color: lightgrey;
  margin: 1em;
  border-radius: 7px;
}
.stretchBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading {
  width: 30vw;
  @media screen and (orientation: portrait) {
    width: 100vw;
  }
}
.searchBar {
  background-color: var(--base-colour, #535450);
  display: grid;
  grid-template-columns: auto auto;
}
.searchButton {
  // border-radius: 0 0 1.5em 1.5em;
  background-color: var(--base-colour, #535450);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.5em;
  padding-right: 1em;
  &:hover {
    background-color: var(--hover-colour, #bbbbbb);
  }
}
</style>